import script from "./EmployeeOptionalsTableActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeOptionalsTableActions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__